<template>
  <transition name="fade">
    <div v-if="toggleModal" class="tw-fixed tw-z-[100] tw-inset-0 tw-overflow-y-auto tw-font-poppins">
      <div class="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-px-4">
        <div style="z-index: -1;" class="tw-fixed tw-inset-0 tw-transition-opacity">
          <div class="tw-absolute tw-inset-0 tw-bg-jrGray-60 tw-opacity-75"></div>
        </div>
        <span class="tw-hidden sm:tw-inline-block tw-align-middle sm:tw-h-screen"></span>&#8203;
        <div class="tw-inline-block tw-align-middle tw-bg-white tw-rounded-lg tw-text-center tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 tw-w-full lg:tw-w-1/3" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="tw-bg-white tw-p-3 tw-border tw-b-bottom">
            <p class="sm:tw-text-sm tw-text-gray-600 tw-font-medium tw-uppercase">Anexos para download</p>
          </div>
          <div class="tw-w-full tw-py-4 tw-px-8 tw-flex tw-flex-col tw-justify-center tw-gap-4">
            <div class="tw-text-white tw-font-poppins" v-for="(anx, idx) in leilao.anexos[0]" :key="idx">
              <a
                class="tw-bg-jrBlue-100 tw-rounded-md tw-px-3 tw-py-1 hover:tw-bg-jrBlue-50"
                :href="`${leiloeiro.dominio_imagens}/anexo/${anx.nm_path}`"
                target="_blank"
                :title="anx.nm"
              >
                {{ (anx.nm) ? anx.nm : 'Anexo' }}
              </a>
            </div>
          </div>
          <div class="tw-flex tw-justify-center">
            <div class="tw-flex tw-px-3 tw-pb-2">
              <button
                @click="modalToggle"
                class="tw-bg-gray-600 tw-text-white tw-px-4 tw-py-1 tw-mt-2 tw-border tw-border-gray-600 hover:tw-bg-gray-800 tw-rounded">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "ModaAnexos",
  props: ['leiloeiro','leilao'],
  data() {
    return {
      toggleModal: false
    }
  },
  methods: {
    modalToggle() {
      this.toggleModal = !this.toggleModal
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/ModalAnexos.vue